export default __webpack_public_path__ + "static/media/video-image.d6a04049.jpg";